import { render, staticRenderFns } from "./AppointmentsDashboard.vue?vue&type=template&id=39f7e076&scoped=true&"
import script from "./AppointmentsDashboard.vue?vue&type=script&lang=js&"
export * from "./AppointmentsDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39f7e076",
  null
  
)

export default component.exports